module.exports = __webpack_public_path__ + "static/headerbg_left-3ffd4892acfd8fd902e88ac15fbd1d6b.gif";